<template>
  <c-modal
    v-model="modal"
    cancel-label="No, Never mind"
    centered
    :hide-header="hideHeader"
    :title="title"
    :tag="false"
    confirm-label="Process with Refund"
    :progressing="progressing"
    :size="thirdContent!=='' ? 'lg' : 'md'"
  >
    <template>
      <div class="upload-photo-text">
        {{firstContent}}
      </div>
      <div class="mt-2 upload-photo-text">
        {{secondContent}}
      </div>
      <div class="mt-2 upload-photo-text">
        {{thirdContent}}
      </div>
      <input
        type="file"
        class="d-none position-absolute"
        id="logoImage"
        :accept="acceptFile"
        @change="changePhoto"
      />
    </template>
    <slot name="content"></slot>
    <template #actions={hide}>
      <b-row class="flex-grow-1">
        <b-col cols="12" sm="6" :md="hasPhoto ? 4 : 6" class="mb-3 mb-md-0">
          <label for="logoImage" v-if="!progressing" class="mb-0 btn btn-warning btn-block w-100">
            Upload Photo
          </label>
          <b-btn v-else block variant="warning" :disabled="progressing">
            Upload Photo
            <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
          </b-btn>
        </b-col>

        <b-col cols="12" sm="6" md="4" v-if="hasPhoto" class="mb-3 mb-md-0">
          <b-btn variant="danger" :disabled="progressing" block class="text-nowrap" @click="deletePhoto">
            Delete Photo
            <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
          </b-btn>
        </b-col>

        <b-col cols="12" sm="6" :md="hasPhoto ? 4 : 6" :class="{'mx-auto': hasPhoto}">
          <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="hide">
            Cancel
          </b-btn>
        </b-col>
      </b-row>
    </template>
    <image-cropper
      v-model="cropModal"
      :src="image"
      :ratio="ratio"
      :vertical-ratio="verticalRatio"
      @completeCrop="completeCrop"
    />
  </c-modal>
</template>

<script>
  import CModal from "./Cmodal";
  import ImageCropper from "@/components/shared/imageCropper";
  export default {
    name: "UploadPhoto",
    components: {ImageCropper, CModal},
    props: {
      hideHeader: {
        type: Boolean,
        default: false
      },
      value: {
        required: true,
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Logo Image Upload',
      },
      firstContent: {
        type: String,
        default: 'Upload a jpg, png or gif file under 20MB with a square size',
      },
      secondContent: {
        type: String,
        default: 'Aspect ration (1:1)',
      },
      thirdContent: {
        type: String,
        default: '',
      },
      acceptFile: {
        type: String,
        default: 'image/*'
      },
      ratio: {
        default: 1/1
      },
      verticalRatio: {
        default: 12 / 16
      },
      progressing: {
        type: Boolean,
        default: false
      },
      hasPhoto: {
        type: Boolean,
        default: false
      },
      maxSize: {
        type: [Number, String],
        default: 20000000
      }
    },
    data () {
      return {
        image: {},
        cropModal: false,
        fileName: ''
      }
    },
    computed: {
      modal: {
        get () {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      changePhoto (e) {
        let file = e.target.files[0];
        if (file.size > this.maxSize) {
          this.$showError(`File size should not more than 20 MB`)
        } else {
          this.fileName = file.name
          const reader = new FileReader();
          reader.onload = (e) => {
            this.image = e.target.result
            this.$nextTick(() => {
              this.cropModal = true
            })
          };
          reader.readAsDataURL(file);
        }
      },
      completeCrop (image, vertical=false) {
        this.cropModal = false
        this.$emit('upload', {image, fileName: this.fileName, vertical})
      },
      deletePhoto () {
        this.$showConfirm(undefined, 'Are you sure to remove this photo?').then(() => {
          this.$emit('delete')
        })
      }
    }
  }
</script>

<style scoped>
  .upload-photo-text{
    font-size: 1rem;
    word-break: break-word;
  }

  @media (max-width: 575.98px){
    .upload-photo-text{
      font-size: 0.9rem;
    }
  }

  @media (min-width: 1200px){
    .upload-photo-text{
      font-size: 1.05rem;
    }
  }
</style>
